import React from 'react';

import cn from 'classnames';

import { UserAvatar } from 'components/UserAvatar/UserAvatar';

import styles from './UserInfo.module.scss';

export const UserInfo = ({
  title,
  superText,
  caption,
  className,
  tooltip,
  initials,
  background = 'gradient',
  onClick = () => {},
}) => (
  <div
    className={cn(styles.root, 'd-flex align-items-start', { [className]: className })}
    onClick={onClick}>
    {initials && (
      <UserAvatar
        background={background}
        className="d-flex align-items-center justify-content-center u-margin-right--small u-no-border">
        <span className="avatar-initials">{initials}</span>
      </UserAvatar>
    )}
    <div className="d-flex flex-column">
      {superText && (
        <span className="text-sm uppercase text-neutral-6 font-medium">{superText}</span>
      )}
      <span className="font-semibold t-body primary-text">{title}</span>
      {caption && <span className="t-small tertiary-text">{caption}</span>}
    </div>
  </div>
);
